import { useForm } from '@inertiajs/react'
import BlogPostForm from "./BlogPostForm"

interface AddBlogPostProps {
  onSuccess?: () => void
}

const AddBlogPost = ({ onSuccess }: AddBlogPostProps) => {
  const { data, setData, post, processing, errors, reset } = useForm({
    title: '',
    excerpt: '',
    content: '',
    slug: '',
    tags_string: '',
    published: false,
    featured: false
  })

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault()
    post('/admin/blog_posts', {
      onSuccess: () => {
        reset()
        onSuccess?.()
      }
    })
  }

  return (
    <BlogPostForm
      data={data}
      setData={setData}
      onSubmit={handleSubmit}
      submitLabel="Add Blog Post"
      processing={processing}
      errors={errors}
    />
  )
}

export default AddBlogPost